type Value = number | boolean | string | undefined | null;

type Data = Record<string, Value | Value[]>;

/**
 * Creates a query string from given data.
 */
export const toQueryString = (data: Data): string => {
  const params = new URLSearchParams();

  Object.entries(data).forEach(([key, value]) => {
    let valueWasArray = Array.isArray(value);
    const valueAsArray = Array.isArray(value) ? value : [value];

    valueAsArray.forEach(value => {
      if (typeof value === 'undefined' || value === null) {
        return;
      }

      if (valueWasArray) {
        key = `${key}[]`;
      }

      if (typeof value === 'boolean') {
        params.append(key, value ? 'true' : 'false');
        return;
      }

      if (typeof value === 'number') {
        params.append(key, value.toString());
        return;
      }

      params.append(key, value);
    });
  });

  return params.toString();
};
